import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'vat'})
export class VatPipe implements PipeTransform {
  public transform(total: number, vatPc : number, sub : boolean = false) : number {
    let vat = total / (1 + vatPc / 100);
    return sub ? vat : total - vat;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/pipe/vat.pipe.ts